import type { BusinessDetail } from "./types";

/**
 * Every list the screens read, defaulted, so a detail that leaves one out
 * renders as an empty list instead of crashing the page.
 */
export function withDefaults(raw: Partial<BusinessDetail>): BusinessDetail {
  return {
    ...(raw as BusinessDetail),
    cin: raw.cin ?? null,
    application: raw.application ?? null,
    offices: raw.offices ?? [],
    people: raw.people ?? [],
    items: raw.items ?? [],
    documents: raw.documents ?? [],
    verificationChecks: raw.verificationChecks ?? [],
    bankAccount: raw.bankAccount ?? null,
    invites: raw.invites ?? [],
    products: raw.products ?? [],
  };
}
